import styled from "styled-components";

export const Card = styled.div`
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  opacity: ${props => props.$isDisabled ? 0.7 : 1};
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
  
  ${props => props.$isDisabled && `
    border-left: 4px solid ${props.theme.colors.danger};
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
  gap: 10px;
`;

export const JobTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  word-break: break-word;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  
  ${props => {
    const c = props.theme.colors;
    if (props.$type === 'disabled') {
      return `
        background-color: ${c.dangerBg};
        color: ${c.dangerText};
        border: 1px solid ${c.dangerBorder};
      `;
    }
    if (props.$type === 'paused') {
      return `
        background-color: ${c.warningBg};
        color: ${c.warningText};
        border: 1px solid ${c.warningBorder};
      `;
    }
    return `
      background-color: ${c.successBg};
      color: ${c.successText};
      border: 1px solid ${c.successBorder};
    `;
  }}
`;

export const CardBody = styled.div`
  margin-bottom: 15px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 14px;
  
  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #6c757d;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  color: #6c757d;
  font-weight: 500;
  min-width: 80px;
`;

export const InfoValue = styled.span`
  color: #333;
  word-break: break-word;
  flex: 1;
`;

export const JobId = styled.code`
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  color: #495057;
  font-family: 'Courier New', monospace;
`;

export const CardFooter = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  border-top: 1px solid #e9ecef;
  padding-top: 15px;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  ${props => {
    const c = props.theme.colors;
    switch (props.$variant) {
      case 'details':
        return `
          background-color: ${c.primary};
          color: ${c.onColor};
          &:hover { background-color: ${c.primaryHover}; }
        `;
      case 'execute':
        return `
          background-color: ${c.success};
          color: ${c.onColor};
          &:hover { background-color: ${c.successHover}; }
        `;
      case 'pause':
        return `
          background-color: ${c.warning};
          color: ${c.gray[900]};
          &:hover { background-color: ${c.warningHover}; }
        `;
      case 'resume':
        return `
          background-color: ${c.info};
          color: ${c.onColor};
          &:hover { background-color: ${c.infoHover}; }
        `;
      case 'disable':
        return `
          background-color: ${c.danger};
          color: ${c.onColor};
          &:hover { background-color: ${c.dangerHover}; }
        `;
      case 'enable':
        return `
          background-color: ${c.success};
          color: ${c.onColor};
          &:hover { background-color: ${c.successHover}; }
        `;
      default:
        return `
          background-color: ${c.secondary};
          color: ${c.onColor};
          &:hover { background-color: ${c.secondaryHover}; }
        `;
    }
  }}
  
  &:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  &:active:not(:disabled) {
    transform: translateY(1px);
  }
`;
